import { render, staticRenderFns } from "./EnacAtplDashboardFilesEditPopup.vue?vue&type=template&id=22879332"
import script from "./EnacAtplDashboardFilesEditPopup.vue?vue&type=script&lang=js"
export * from "./EnacAtplDashboardFilesEditPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports